export default __webpack_public_path__ + "static/media/absolute-4.89d4ba14.png";